<template>
    <el-dialog class="dialog" :visible="dialogs.spk" customClass="dialog_main" :append-to-body="true" :close-on-click-modal="false" @close="closeDialog()" @open="handleOpen">
        <div slot="title" class="dialog__head dialog__head_second">
            <div class="dialog__head-inner">
              <h3 class="dialog__title">
                <template v-if="this.activeSPK.id">Редактирование СПК</template><template v-else>Создание СПК</template>
              </h3>
            </div>
        </div>

        <div slot="default" class="dialog__inner">
            <form
                action="#"
                class="dialog__form"
                @submit.prevent="createOrUpdateSpk"
                autocomplete="off"
            >
                <div class="dialog__content">
                    <input type="text" name="name" class="input" placeholder="Название организации" v-model="newSpkName" required>

                    <v-select v-if="activeEl === 1" class="select mt-16" name="organisation_id" placeholder="Id СПК" label="name" v-model="newSpkOrganisationId" :clearable="false" :options="spkOrganisation">
                        <template #no-options="{ search, searching, loading }">
                            {{ SELECT_NOT_FOUND }}
                        </template>
                        <template #open-indicator="{ attributes }">
                            <span v-bind="attributes">
                                <icon-base width="14" height="8" viewBox="0 0 14 8" iconColor="#000"><icon-arrow-down /></icon-base>
                            </span>
                        </template>
                    </v-select>
                
                    <div class="mt-16">
                        <label class="dialog__label">Укажите статус организации</label>

                        <ul class="entry-list dialog__content-blocks mt-12 mb-24">
                            <li class="entry-list__item career-trajectory-page__list-item-clickable" v-for="item in organisationStatuses" :key="item.id" :class="{ 'career-trajectory-page__list-item_active': activeEl === item.id }" @click="activeEl = item.id">
                                <div class="entry entry_48-height">
                                    <div class="entry__inner">
                                        <div class="entry__item">
                                            <p class="career-trajectory-page__list-item-text">{{ item.name }}</p>
                                        </div>
                                        <div class="career-trajectory-page__icon_success entry__item" v-if="activeEl === item.id">
                                            <icon-base width="14" height="10" viewBox="0 0 12 10"><icon-success /></icon-base>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>

                <footer slot="footer" class="dialog__footer mt-24">
                    <div class="dialog__footer-inner">
                        <div class="dialog__footer-item ml-auto">
                            <button type="submit" class="btn btn_action" :disabled="!newSpkName || newSpkName.length === 0 || activeEl === null || (activeEl === 0 ? false : (!newSpkOrganisationId || newSpkOrganisationId.length === 0))">
                                <template v-if="this.activeSPK.id">Обновить</template><template v-else>Создать</template>
                            </button>
                        </div>
                    </div>
                </footer>
            </form>
        </div>
    </el-dialog>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';

import constants from '@/constants.js';
import dialog from '@/mixins/dialog';

export default {
    mixins: [ dialog ],
    props: {
        activeSPK: {
            type: Object,
            default: function() {
                return {}
            }
        },
    },
    data() {
        return {
            activeEl: null,
            newSpkName: null,
            newSpkOrganisationId: null,
            organisationStatuses: [
                {
                    name: 'СПК',
                    id: 1
                },
                {
                    name: 'Организация',
                    id: 0
                },
            ]
        }
    },
    methods: {
        ...mapActions('spk', ['LOAD_SPK_ORGANISATION', 'CREATE_SPK', 'UPDATE_SPK']),

        closeDialog() {
            this.newSpkName = null
            this.activeEl = null
            this.newSpkOrganisationId = null
            
            this.elDialogs.spk = false;
        },
        onlyNumber(e) {
            if ((e.keyCode < 48 || e.keyCode > 57)) {
                e.preventDefault();
            } else {
                return true;
            }
        },
        async createOrUpdateSpk(e) {
            const formData = new FormData(e.target);

            const params = {
                is_spk: !!this.activeEl,
            };

            if (this.newSpkOrganisationId) {
                params.organisation_id = this.newSpkOrganisationId.id
            }

            for (const pair of formData.entries()) {
                params[pair[0]] = pair[1];
            }

            if (this.activeSPK.id) {
              await this.UPDATE_SPK({spkId: this.activeSPK.id, params});
            } else {
              await this.CREATE_SPK(params);
            }

            this.closeDialog();
        },
        renameSpk(e) {
            this.closeDialog();
        },
        handleOpen() {
          this.LOAD_SPK_ORGANISATION();

          if (this.activeSPK.id) {
            this.newSpkName = this.activeSPK.name;
            this.activeEl = this.activeSPK.is_spk;
            this.newSpkOrganisationId = this.spkOrganisation.find(el => el.id === this.activeSPK.organisation_id);
          }
        }
    },
    computed: {
        ...mapState('spk', ['spkOrganisation']),
    }
}
</script>
